import Queue from "nq";

class SignOutUseCase {
  async execute() {
    return new Queue.User().signOut();
  }
}

export default SignOutUseCase;
